import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 20px 40px;

  header {
    margin-bottom: 20px;
  }

  header h1 {
    margin-bottom: 4px;
  }

  header span {
    color: #666;
  }

  table {
    width: 100%;
    border-spacing: 0;
    margin-top: 24px;
  }

  table th {
    font-size: 22px;
    text-align: left;
    font-weight: 400;
    background: #f1f1f1;

    padding: 10px;

    & + th {
      border-left: 1px solid #ddd;
    }
  }

  table td {
    font-size: 16px;
    padding: 10px;
  }

  table tr:nth-child(even) td {
    background: #f5f5f5;
  }

  table th:last-child,
  table td:last-child {
    text-align: right;
  }
`;

export const Filters = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: 12px;

  margin-top: 24px;
  margin-bottom: 22px;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    width: fit-content;

    border-radius: 8px;
    border: 1px solid transparent;
    padding: 0 16px;
    background: #e1e1e1;
    cursor: pointer;

    &:first-child {
      color: #fff;
      border-color: #7284ff;
      background: #7284ff;
    }

    &:hover,
    &:active {
      border-bottom-color: #ccc;
    }

    &[disabled] {
      cursor: default;
      opacity: 0.8;
    }
  }

  button:active {
    transform: scale(0.98);
    top: 10px;
  }

  svg {
    margin-right: 8px;
  }
`;

export const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 10px;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 13px;
    color: #555;
    margin-bottom: 6px;
  }

  input,
  select {
    height: 42px;
    border: 1px solid #d8d8d8;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 14px;
    background: #fff;
  }
`;

export const AlertWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  color: #333;
  font-size: 18px;
  background: #f5f5f5;
  padding: 24px 0;
  border-radius: 8px;
`;

export const KpiGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(4, minmax(160px, 1fr));
  gap: 12px;
`;

export const KpiCard = styled.article`
  background: #f7f8ff;
  border: 1px solid #e4e8ff;
  border-radius: 10px;
  padding: 12px;

  small {
    color: #666;
    display: block;
    margin-bottom: 6px;
  }

  strong {
    color: #303f9f;
    font-size: 22px;
  }
`;

export const TopList = styled.section`
  margin-top: 18px;
  padding: 14px;
  border: 1px solid #ececec;
  border-radius: 10px;
  background: #fff;

  h3 {
    margin-bottom: 10px;
  }

  p {
    color: #666;
  }

  ul {
    list-style: none;
  }

  li {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #efefef;
    padding: 7px 0;
  }
`;
